import React, { Component } from 'react'

export default class Sidebar extends Component {
  render() {
    return (
      <div className='sidebar'>
        <div className='sidebar-text'>
          Sidebar eyyyy
        </div>
      </div>
    )
  }
}
